import { render, staticRenderFns } from "./OtherAccident.vue?vue&type=template&id=6d8d9cc8"
import script from "./OtherAccident.vue?vue&type=script&lang=js"
export * from "./OtherAccident.vue?vue&type=script&lang=js"
import style0 from "./OtherAccident.vue?vue&type=style&index=0&id=6d8d9cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports